import { createSelector } from "@ngrx/store";
import { RootSelectors } from "../app.selector";
import { User } from "../../beans/User";


export const UserSelectors = {
    USER: createSelector(RootSelectors.USER, (user: User) => user)
}
